import { Link } from '@tanstack/react-router';

import { Button } from '@/components/button.js';
import { Page } from '@/components/page.js';
import { useTranslation } from 'react-i18next';

export function NotFoundPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <Page title={t('support.notFound')} description={t('support.notFoundDescription')}>
      <Button asChild variant="outline">
        <Link to="/">{t('support.backToDashboard')}</Link>
      </Button>
    </Page>
  );
}
